export const PTR_LENGTH = 7;